export default {
  home: {
    lang: '中文',
    lang_cn: 'Traditional Chinese',
    lang_en: 'English',
    form_title: '[Asia Coffee Music Festival x V27 First Debut | March 6-8]',
    form_title2: 'Register now  to be the first to book V27',
    submit: 'Submit',
    mandatory: 'Mandatory',
    yes: "Yes",
    no: "No",
    lastName: 'Last name',
    firstName: 'First name',
    enterLastName: 'Please enter your last name',
    enterFirstName: 'Please enter your first name',
    emailAddress: 'Email address',
    enterEmail: 'Please enter your email',
    rightEmail: 'Please enter the correct email address!',
    mobileNumber: 'Mobile number',
    enterPhone: 'Please enter your phone number',
    rightPhone: 'Please enter the correct phone number!',
    privacyPolicy: "I/We agree with the use of my/our personal data by KLM,its affiliates, subsidiaries and associated companies for direct marketing purposes in accordance with the Personal Information Collection Statement and the Privacy Policy Statement.",
    appellation: 'Title',
    selectAppellation: 'Please select a title',
    corporateClient: 'Corporate client',
    selectLanguage: 'Select language',
    pleaseSelectLanguage: 'Please select language',
    InformationSubmitted: 'It has been submitted, thank you!',
    success: 'Success !',
    pleaseWriteName: 'company name',
    pleaseWriteName_: 'If so, please provide the company name',
    agree_: 'I/We have read and agree to the',
    statement_: 'Personal lnformation Collection Statement',
    policy_: 'Privacy Policy Statement',
    and: ' and ',
    corporateClient_: 'Please select a corporate customer',
    _policy: 'Please check “privacy policy”',
    remark: 'Remark',
    fullStop: '.',
    exception: 'Network error, please submit again later!',
    pay: "Pay HK $1,000"
  },
  appellation: {
    Sir: 'Mr.',
    lady: 'Mrs.',
    Miss: 'Miss',
    PhD: 'Dr.',
    professor: 'professor',
  },
  carOption: {
    cartitle: 'Preferred model',
    car1: 'V27 (RHD)',
    car2: 'V27 Sport (AWD)',
    carModel_: 'Please select your preferred model'
  },
  successPage: {
    congratulations: 'Congratulations! You have successfully made a reservation',
    unfinished: 'You have not completed the payment!',
    rePayment: 're-payment',
    error: 'Access parameter error!',
    confirm: 'confirm',
    cancel: 'cancel',
    Cancelled: 'You have canceled!',
    toHome: 'Are you sure you want to close and return to the homepage?',
    rePay: 'Are you sure you want to re-pay the deposit?',
    wait1: 'Confirming payment result',
    wait: 'It is expected to be completed within 5 seconds. Please do not close the page',
  }
};

